import {EducationResource} from '@/common/api/api-raw-types';
import {Education} from '../../../domain/Profile';

export function toEducation(educationResource: EducationResource): Education {
    return {
        content: educationResource.content,
        description: educationResource.description,
        graduationYear: educationResource.graduationYear,
        title: educationResource.title,
    };
}
